import { render, staticRenderFns } from "./ICalEventDetails.vue?vue&type=template&id=69c56f35&scoped=true&"
import script from "./ICalEventDetails.vue?vue&type=script&lang=ts&"
export * from "./ICalEventDetails.vue?vue&type=script&lang=ts&"
import style0 from "./ICalEventDetails.vue?vue&type=style&index=0&id=69c56f35&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69c56f35",
  null
  
)

export default component.exports